import { modifyPageLayoutComponents } from '../../PageLayout';
import { FeatureSelection, FeatureSelectionHeader, FeatureSelectionSubHeader, FeatureSelectionFooter } from './featureSelection';

export const FeatureSelectionComponents = modifyPageLayoutComponents({
  pageHeader: FeatureSelectionHeader,
  pageMenu: FeatureSelectionSubHeader,
  content: FeatureSelection,
  pageFooter: FeatureSelectionFooter
});
